import * as React from 'react';
export var DEFAULT_DESCRIPTION_MESSAGE = (React.createElement(React.Fragment, null,
    "We track these errors automatically, but if the problem persists feel free to contact us. ",
    React.createElement("br", null),
    "You could also try refreshing the page."));
export var UNAUTHORIZED_DESCRIPTION_MESSAGE = (React.createElement(React.Fragment, null,
    "The provided authentication credentials were invalid. ",
    React.createElement("br", null),
    "Please logout and login again."));
//# sourceMappingURL=constants.js.map